import React, { useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Box,
    Typography
} from '@mui/material';
import { Icon } from '@iconify/react';
import { useNavigate, useLocation } from 'react-router-dom';

const SessionExpiredModal = ({ isOpen }) => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (isOpen) {
            const handlePopState = (e) => {
                e.preventDefault();
                navigate(location.pathname, { replace: true });
            };

            window.addEventListener('popstate', handlePopState);
            window.history.pushState(null, '', window.location.pathname);

            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }
    }, [isOpen, navigate, location]);
    const handleClose = (event, reason) => {
        return false;
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            disableEscapeKeyDown
            hideBackdrop
            aria-labelledby="session-expired-dialog"
            PaperProps={{
                sx: {
                    maxWidth: '400px',
                    width: '90%',
                    m: 2,
                    borderRadius: '16px',
                    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)'
                }
            }}
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)'
                }
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: 'center',
                    pt: 4,
                    pb: 2
                }}
            >
                <Icon
                    icon="ic:round-error-outline"
                    style={{
                        fontSize: '48px',
                        color: '#EF4444',
                        marginBottom: '16px'
                    }}
                />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1E293B' }}>
                    Session Expired
                </Typography>
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={{
                    textAlign: 'center',
                    color: '#64748B',
                    px: 2,
                    pb: 4
                }}>
                    Your session has expired. Please close the browser or application and restart it to continue.
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default SessionExpiredModal;